export var ProgressBarStep;
(function (ProgressBarStep) {
    ProgressBarStep["HOMEPAGE"] = "HOMEPAGE";
    ProgressBarStep["DESTINATION"] = "DESTINATION";
    ProgressBarStep["HOTEL_LIST"] = "HOTEL_LIST";
    ProgressBarStep["INFO_AND_DATES"] = "INFO_AND_DATES";
    ProgressBarStep["DETAILS"] = "DETAILS";
    ProgressBarStep["RESERVATION"] = "RESERVATION";
    ProgressBarStep["CHOOSE_CONNECTION"] = "CHOOSE_CONNECTION";
    ProgressBarStep["PERSONAL_DATA"] = "PERSONAL_DATA";
})(ProgressBarStep || (ProgressBarStep = {}));
var ProgressBarStepDetector = /** @class */ (function () {
    function ProgressBarStepDetector() {
    }
    ProgressBarStepDetector.detectProgressBarStep = function (url) {
        if (!url) {
            return ProgressBarStep.DESTINATION;
        }
        if (url.match(this.startPattern + this.anyPattern + this.languagePattern + this.anyPattern + '\\-'
            + this.giataPattern + '(\\?.*$|$)')) {
            return ProgressBarStep.INFO_AND_DATES;
        }
        if (url.match(this.startPattern + this.anyPattern + this.languagePattern + this.anyPattern +
            '/weltweit' + this.anyPattern + this.endPattern)
            || url.match(this.startPattern + this.anyPattern + this.languagePattern + '/reisearten'
                + this.anyPattern + this.endPattern)
            || url.match(this.startPattern + this.anyPattern + this.languagePattern + '/reisethemen'
                + this.anyPattern + this.endPattern)
            || url.match(this.startPattern + this.anyPattern + this.languagePattern + '/pauschalreisen'
                + this.anyPattern + this.endPattern)
            || url.match(this.startPattern + this.anyPattern + '/fr/' + this.anyPlusPattern + '/vacances'
                + this.anyPattern + this.endPattern)
            || url.match(this.startPattern + this.anyPattern + '/fr/' + this.anyPlusPattern + '/dans-le-monde-entier'
                + this.anyPattern + this.endPattern)
            || url.match(this.startPattern + this.anyPattern + '/fr/typesdevoyages' +
                this.anyPattern + this.endPattern)
            || url.match(this.startPattern + this.anyPattern + '/fr/hotel/vacances' +
                this.anyPattern + this.endPattern)
            || url.match(this.startPattern + this.anyPattern + '/fr/hotel/dans-le-monde-entier' +
                this.anyPattern + this.endPattern)
            || url.match(this.startPattern + this.anyPattern + '/fr/voyagespartheme' + this.anyPattern
                + this.endPattern)) {
            return ProgressBarStep.DESTINATION;
        }
        if (url.match(this.startPattern + this.anyPattern + this.languagePattern + this.anyPattern +
            '/index')) {
            return ProgressBarStep.HOMEPAGE;
        }
        return ProgressBarStep.HOTEL_LIST;
    };
    ProgressBarStepDetector.startPattern = '^';
    ProgressBarStepDetector.endPattern = '$';
    ProgressBarStepDetector.languagePattern = '\/[a-zA-z]{2}';
    ProgressBarStepDetector.anyPattern = '.*';
    ProgressBarStepDetector.anyPlusPattern = '.+';
    ProgressBarStepDetector.giataPattern = '[0-9]{1,7}';
    return ProgressBarStepDetector;
}());
export default ProgressBarStepDetector;
